import React, {useRef} from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import styled, {css} from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import {hoje} from '../Helpers/date';

function onClickButton ({value,op,onChange,minValue,anoVigente}) {
  if (op === "inc" && value >= anoVigente)
    return false
  if (minValue && op === "dec" && minValue >= value)
    return false
  let fn = (op === "inc") ? (a => a + 1) : (a => a - 1);
  return () => onChange(value => fn(value))
}

function Button (props) {
  const { op } = props;
  const onClick = onClickButton(props);
  return (
    <IconButton onClick={onClick} disabled={!Boolean(onClick)}>
      <KeyboardArrowLeft style={op==="inc" ? {transform:"rotate(180deg)"}:{}} />
    </IconButton>
  )
}

const Container = styled.div`
  display: inline-flex;
  flex-grow: 1;
  position: relative;
  ${({width}) => width && css`
    width: ${width};
  `}
  ${({fullWidth}) => fullWidth && css`
    width: 100%;
  `}
`

function renderInput(props) {
  const {
    autoComplete,
    autoFocus,
    defaultValue,
    fullWidth,
    id,
    inputProps,
    InputProps,
    inputRef,
    minValue,
    multiline,
    name,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    rows,
    rowsMax,
    type,
    value,
  } = props;
  return (
    <Input
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      defaultValue={defaultValue}
      fullWidth={fullWidth}
      multiline={multiline}
      name={name}
      rows={rows}
      rowsMax={rowsMax}
      type={type}
      value={value}
      id={id}
      inputRef={inputRef}
      onBlur={onBlur}
      onChange={e => onChange(parseInt(e.target.value))}
      onFocus={onFocus}
      placeholder={placeholder}
      inputProps={inputProps}
      startAdornment={
        <InputAdornment position="start">
          <Button inputRef={inputRef} op="dec" {...props} />
        </InputAdornment>
      }
      endAdornment={
        <InputAdornment position="end">
          <Button inputRef={inputRef} op="inc" {...props} />
        </InputAdornment>
      }
      {...InputProps}
    />
  )
}

export default function SeletorAno (props) {
  const {
    className,
    FormHelperTextProps,
    fullWidth,
    width,
    id,
    InputLabelProps,
    label,
    value,
    minValue,
    onChange,
    required,
    variant,
    suggestions,
    ...other
  } = props;
  let {ano:anoVigente} = hoje();
  let helperText;
  if (value < minValue) helperText = "Valor inválido";
  if (value > anoVigente) helperText = "Valor inválido";
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const inputRef = useRef(null);
  return (
    <Container fullWidth={fullWidth} width={width} >
      <FormControl
        aria-describedby={helperTextId}
        className={className}
        error={Boolean(helperText)}
        fullWidth={fullWidth}
        required={required}
        variant={variant}
        {...other}
      >
        {label && (
          <InputLabel htmlFor={id} {...InputLabelProps}>
            {label}
          </InputLabel>
        )}
        {renderInput({...props, inputRef, anoVigente})}
        {helperText && (
          <FormHelperText id={helperTextId} {...FormHelperTextProps}>
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
    </Container>
  )
}
